"use client";

import React, { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";

const galleryItems = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_10f124528-1765233620121.png",
  alt: "Live performance on stage by Hi-Hats students at Rajanukunte event",
  span: "col-span-2 row-span-2",
  label: "Live Performance Night"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_10bdd52bc-1767948121585.png",
  alt: "Students jamming together in group music session at Hi-Hats",
  span: "col-span-1 row-span-1",
  label: "Jam Session"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1864325b4-1772041648325.png",
  alt: "Vocalist performing on stage at Hi-Hats music academy event",
  span: "col-span-1 row-span-1",
  label: "Vocal Showcase"
},
{
  src: "https://images.unsplash.com/photo-1598125009481-2335662dbf66",
  alt: "Close up of guitarist hands playing electric guitar at Hi-Hats",
  span: "col-span-1 row-span-1",
  label: "Guitar Mastery"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_113a37bfd-1765157509682.png",
  alt: "Drum kit being played in energetic session at Hi-Hats Rajanukunte",
  span: "col-span-1 row-span-1",
  label: "Rhythm Workshop"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16c7a850f-1765905205749.png",
  alt: "Art and craft workshop students displaying their creative work",
  span: "col-span-1 row-span-1",
  label: "Art Workshop"
}];


export default function GallerySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".reveal-hidden").forEach((el) => {
              el.classList.add("revealed");
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="gallery"
      ref={sectionRef}
      className="py-24 md:py-32 relative"
      style={{ background: "#0e0e0e" }}>
      
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="reveal-hidden">
            <span className="badge-blue px-3 py-1 rounded-full text-xs font-display font-bold uppercase tracking-widest">
              Community
            </span>
            <h2
              className="font-display font-black mt-4 leading-tight tracking-tight"
              style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>
              
              Performance &amp;{" "}
              <span className="text-yellow">Jam Gallery</span>
            </h2>
            <p
              className="mt-2 text-base"
              style={{ color: "rgba(255,255,255,0.5)" }}>
              
              Real students. Real performances. Real energy.
            </p>
          </div>
          <a
            href="#enroll"
            className="btn-outline inline-block px-6 py-3 rounded-xl text-sm font-display font-bold reveal-hidden whitespace-nowrap self-start md:self-auto">
            
            Join the Community →
          </a>
        </div>

        {/* Gallery Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          style={{ gridAutoRows: "200px" }}>
          
          {galleryItems?.map((item, i) =>
          <div
            key={`gallery-${i}`}
            className={`gallery-item rounded-2xl overflow-hidden relative reveal-hidden stagger-${Math.min(i + 1, 4)} ${i === 0 ? 'sm:col-span-2 sm:row-span-2 lg:col-span-2 lg:row-span-2' : ''}`}>
            
              <AppImage
              src={item?.src}
              alt={item?.alt}
              className="w-full h-full object-cover" />
            
              {/* Overlay */}
              <div
              className="absolute inset-0 opacity-0 transition-opacity duration-400"
              style={{
                background: "linear-gradient(to top, rgba(17,17,17,0.85) 0%, transparent 60%)"
              }} />
            
              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 p-4 opacity-0 transition-all duration-400 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 gallery-label">
                <span
                className="text-xs font-display font-bold uppercase tracking-widest"
                style={{ color: "#F2C94C" }}>
                
                  {item?.label}
                </span>
              </div>
              {/* Blue glow on hover handled by CSS .gallery-item::after */}
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 reveal-hidden">
          <p className="text-sm mb-4" style={{ color: "rgba(255,255,255,0.4)" }}>
            Follow us for more live performances and student showcases
          </p>
          <div className="flex justify-center gap-4">
            {[
            { label: "Instagram", icon: "📸", href: "#" },
            { label: "YouTube", icon: "▶️", href: "#" },
            { label: "Facebook", icon: "👥", href: "#" }]?.
            map((s) =>
            <a
              key={s?.label}
              href={s?.href}
              className="social-icon flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-display font-semibold"
              style={{ color: "rgba(255,255,255,0.6)" }}
              aria-label={`Follow Hi-Hats on ${s?.label}`}>
              
                <span>{s?.icon}</span>
                <span>{s?.label}</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>);

}